import { useI18n } from "providers/I18n"
import { CellProps } from "components/TreeState"
import { NEGOTIATION_TYPES } from "models/ratecard"
import { ListCell } from "./ListCell"
import { get } from "lodash"
import { useSnapshot } from "valtio"
import { useTableSource } from "../TableStateProvider"
import { isSemanticReadonly } from "../utils"
import { PlanRecordType } from "../types"
import { FieldsKey } from "../components/AutoCompute/types"

const options = (t: (key: string) => string) =>
  NEGOTIATION_TYPES?.map((nt) => ({
    value: nt,
    label: t(`rate.card.negotiation.type._${nt}`),
  }))

export function NegotiationTypeCell(props: CellProps) {
  const { t } = useI18n()
  const { rowId: id, dataKey, disabled, semantic, primaryKey } = props
  const tableSource = useTableSource()
  const readFrom = useSnapshot(tableSource.state)
  const type = readFrom[id]?.type as PlanRecordType
  const packaged = readFrom[id]?.packaged

  const selected =
    type === "line_item"
      ? (get(readFrom[id], `${dataKey}.negotiationType`) as string)
      : undefined

  const readonly =
    isSemanticReadonly(type, primaryKey as FieldsKey, semantic, packaged) ||
    disabled

  return (
    <ListCell
      {...props}
      options={options(t)}
      selected={selected}
      disabled={readonly}
      dataKey={dataKey}
      normalize={(value: string) =>
        !!value ? { negotiationType: value } : null
      }
      disableClearable
    />
  )
}
